/**
 * AddVodCtrl controller
 * Add/edit VODs
 */

import moment from 'moment'
import {
  DRM_ACCOUNT_TYPES,
  PLATFORM_TYPES, RESOLUTIONS,
  TAG_CUSTOM_ERROR_TYPES,
  URL_PATTERN
} from 'app/core/constants'
import { getId } from '../../app/helpers/entity'
import { formatDateByTimezone } from '../../app/helpers/date'
import { ensureOfflinePlaybackDefaults, resetOfflineExpirationIfDisabled } from '../../app/helpers/offlinePlayback'
import { openAssignContentSets } from '../common/directives/contentItems/ci.directives'

// controller mixins
AddVodCtrl.mixes = [
  ['m2mCtrlMixin', 'vod', 'networks'],
  ['m2mCtrlMixin', 'vod', 'categories'],
  ['m2mCtrlMixin', 'vod', 'tags']
]

/**
 * AddVodCtrl controller
 *
 * @class AddVodCtrl
 * @memberof mwApp/vods
 * @see mwApp/vods
 * @mixes mwApp/common.mixin:m2mCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/vods.controller:AddVodCtrl
 */
/* @ngInject */
export default function AddVodCtrl ($timeout, $state, $scope, $transition$, $location, $uibModal, UrlPolicy, VOD, VODSet, Show, Season, PartnerProgram, extra, vod, authSvc, alertSvc, alertLiteSvc, storageSvc, allNetworksById) {
  const vm = this
  vm.mixes = [['tabsCtrlMixin', '', 'fillFromTMDb', 'fillFromLink']]

  vm.urlPattern = URL_PATTERN
  vm.partnerProviders = {}
  vm.resolutions = authSvc.hasEnabledFlag('FEATURE_DOLBY_4K_ENABLED') ? RESOLUTIONS : ['SD', 'HD', '_4K']

  PartnerProgram.loadExtra().then(({ allowedPartnerProviderTypes }) => {
    vm.partnerProviders = allowedPartnerProviderTypes
  })

  $scope.$watch('vm.isEpisode', (n) => {
    if (n) {
      // load data
      Show.searchShows('')
        .data()
        .then((data) => data.payload)
        .to(vm.shows = [])
    }
  })

  /**
   * Default values for table state
   *
   * @type {Object}
   */
  const defaultTableState = {
    page: 0,
    count: 25,
    name: '',
    last: false
  }

  /**
   * VOD
   *
   * @memberof mwApp/packages.controller:AddVodCtrl
   * @type {models.VOD}
   */
  vm.vod = vod

  ensureOfflinePlaybackDefaults(vm.vod)

  /**
   * isNew flag
   *
   * @memberof mwApp/packages.controller:AddVodCtrl
   * @type {Boolean}
   */
  vm.isNew = vod._isNew()

  if (!vm.isNew && vod.networks.length === 0) {
    vm.networkSelected = { id: 0, name: 'All Organizations' }
  }

  if (!vm.isNew) {
    vod.contentSets.forEach(cs => { cs.networkName = allNetworksById[cs.networkId]?.name })
  }

  /**
   * DRM account types
   *
   * @memberOf mwApp/channels.controller:AddCodCtrl
   * @type {Object}
   */
  vm.drm_account_types = DRM_ACCOUNT_TYPES

  /**
   * AuthSvc service
   *
   * @memberof mwApp/vods.controller:AddVodCtrl
   * @type {AuthSvc}
   */
  vm.authSvc = authSvc

  /**
   * Loader indicator
   *
   * @type {boolean}
   */
  $scope.loading = true

  /**
   * Current year, top limit for VOD year
   * There is no movies from future, rigth? :)
   *
   * @memberof mwApp/packages.controller:AddVodCtrl
   * @type {Number}
   */
  vm.maxYear = moment().year() + 5

  /**
   * '»' symbol to use on "Category » SubCategory" buttons, instead of &raquo; or »
   *
   * @memberof mwApp/packages.controller:AddVodCtrl
   * @type {String}
   */
  vm.raquoSymbol = ' ' + String.fromCharCode(187) + ' '

  /**
   * Platform types
   *
   * @memberof mwApp/packages.controller:AddVodCtrl
   * @type {Object[]}
   */
  vm.platformTypes = angular.copy(PLATFORM_TYPES.filter((p) => {
    return !(!authSvc.hasEnabledFlag('WEB_PLATFORM_ENABLED') && p.name === 'WEB')
  }))

  /**
   * Is episode
   *
   * @memberof mwApp/packages.controller:AddVodCtrl
   * @type {Boolean}
   */
  vm.isEpisode = false

  vm.currentTag = { search: '' }

  /**
   * Show string for search
   *
   * @memberof mwApp/shows.controller:AddVodCtrl
   * @type {String}
   */
  vm.selectedShow = ''
  vm.tagSelected = []
  vm.tagSelected = vm.vod.tags
  vm.tags = null

  /**
   * TV Shows list
   *
   * @memberof mwApp/shows.controller:AddVodCtrl
   * @type {[]}
   */
  vm.shows = []

  /**
   * Seasons list
   *
   * @memberof mwApp/shows.controller:AddVodCtrl
   * @type {[]}
   */
  vm.seasons = []

  /**
   * Custom error for tag field
   *
   * @memberof mwApp/shows.controller:AddVodCtrl
   * @type {Array}
   */
  vm.tagErrors = []

  /**
   * Table state for networks sets
   *
   * @memberof mwApp/shows.controller:AddVodCtrl
   * @type {defaultTableState}
   */
  vm.tableState = angular.copy(defaultTableState)

  /**
   * Networks sets
   *
   * @memberof mwApp/shows.controller:AddVodCtrl
   * @type {Array}
   */
  vm.networksSets = []

  /**
   * Set VOD as free
   *
   * @memberof mwApp/packages.controller:AddVodCtrl
   * @function
   */
  vm.setFree = set => {
    if (set) {
      vm.isFree = true
    } else {
      vm.isFree = !vod.price
    }
  }

  /**
   * Disable not enable items
   * @param item
   * @returns {boolean}
   */
  vm.disableChoice = (item) => {
    return !item.enabled
  }

  /**
   * Upload logo
   *
   * @memberof mwApp/packages.controller:AddVodCtrl
   * @function
   */
  function uploadLogo (file, type) {
    return vod._uploadFile(null, file, {
      type
    }).data()
  }

  /**
   * Validate, if at least one platform is checked
   *
   * @memberof mwApp/packages.controller:AddVodCtrl
   */
  vm.atLeastOnePlatform = function () {
    for (let i = vm.platformTypes.length; i--;) {
      if (vm.platformTypes[i].checked) {
        return false
      }
    }
    return true
  }

  // fix VOD field values
  vod.urls = vod.urls || {}

  vm.formatLength = function (l) {
    const hours = l ? +l.split(':')[0] : 0
    const minutes = l ? +l.split(':')[1] : 0
    const seconds = l ? +l.split(':')[2] : 0
    const date = new Date()
    date.setHours(hours)
    date.setMinutes(minutes)
    date.setSeconds(seconds)
    return date // .toISOString()
  }

  // get Date object from duration/length
  vod.lengthISO = vm.formatLength(vod.length)

  // load extra
  Object.assign(vm, extra)
  for (const prop in vod.urls) {
    if (Object.prototype.hasOwnProperty.call(vod.urls, prop)) {
      if (!vod.urls[prop]) {
        continue
      }

      if (vod.urls[prop].drmProfiles) {
        for (let i = 0; i < vod.urls[prop].drmProfiles.length; i++) {
          const findProfile = vm.drmProfiles.find((dp) => dp.id === vod.urls[prop].drmProfiles[i].id)

          if (findProfile) {
            vod.urls[prop].drmProfiles[i] = angular.copy(findProfile)
          }
        }
      }
    }
  }

  vm.listOfNetworks = angular.copy(vm.networks.concat(vod.networks))
  if (!vm.isNew && vod.networks.length === 0) {
    vod.networks = vm.networks
    vm.networks = [{ id: -1, name: 'Deselect all Organization' }]
  } else {
    const existingNetworks = vod.networks.map(getId)
    vm.networks = [{ id: 0, name: 'All Organizations' }].concat(vm.networks.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)))
      .filter(n => existingNetworks.indexOf(n.id) === -1)
  }
  $scope.loading = false

  /**
   * ! Need refactoring START !
   */

  vm.currentVodState = angular.copy(vm.vod)
  vm.language = []
  vm.searchParams = {
    language: null,
    countryForAR: null,
    title: '',
    adult: false
  }

  if (authSvc.hasEnabledFlag('TMDB_ENABLED')) {
    VOD.getLanguage().then(res => {
      vm.languages = res
      vm.searchParams.language = vm.languages.find(l => l.isoCode === 'en')
    })
  }

  vm.vodsFromDB = []

  vm.getRating = function () {
    if (vm.vod.$ageRatingType === 'default') {
      return vm.ageRatings.defaultAgeRatings
    } else {
      if (vm.vod.$country) {
        return vm.ageRatings.customAgeRatings.find(r => r.id === vm.vod.$country.id).ageRatings
      }
    }
  }

  vm.ageRatings = JSON.parse(storageSvc.local.get('ageRatings'))
  vm.countries = JSON.parse(storageSvc.local.get('countries'))
  if (vm.countries.length) {
    vm.searchParams.countryForAR = vm.countries.find(c => c.isoCode === 'GB')
    vm.searchParams.countryForAR = vm.countries.find(c => c.isoCode === 'GB')
  }

  if (!vm.isNew && vod.ageRating) {
    if (vm.vod.$ageRatingType === 'default') {
      vm.vod.$defaultAgeRating = vm.ageRatings.defaultAgeRatings.find(r => r.id === vod.$defaultAgeRating.id)
      vm.vod.ageRating = null
    } else {
      vm.vod.$country = vm.countries.find(c => c.id === vod.$country.id)
      const country = vm.ageRatings.customAgeRatings.find(c => c.id === vod.$country.id)
      vm.vod.ageRating = country.ageRatings.find(r => r.id === vm.vod.ageRating.id)
      vm.vod.$defaultAgeRating = null
    }
  }

  /**
   * ! Need refactoring END !
   */

  /**
   * Create/update VOD
   *
   * @memberof mwApp/packages.controller:AddVodCtrl
   */

  vm.lengthError = false

  vm.afterSaveActions = function () {
    if (vm.isNew && authSvc.hasAccess('editVod')) {
      VOD.loadAvailableContentSets(vod)
        .then(data => {
          if (data.length) {
            alertSvc.confirm(`${vod.name} VOD has added. <br> Do You want to assign this VOD to the VOD Set(s)?`)
              .then(() => {
                openAssignContentSets($state, $location, vod, true)
              })
          }
        })
    }
  }

  vm.save = function (type = 'default', form = {}) {
    for (const control of form.$$controls) {
      control.$setDirty()
      control.$validate()
    }

    if (!vm.vod.publishTime) {
      if (vm.vod.$scheduledPublishing) {
        vm.dpCfg.changeHandler(form)
      }
    }

    if (form.$invalid) {
      return
    }

    if (vm.isEpisode || vm.tagErrors.length) {
      return
    }

    if (type === 'fromTMDB') {
      vod.tmdbId = vm.selectedVod.tmdbId
    }

    // validation for posters
    if (!vm.vod.imageUrl || !vm.vod.imageBackgroundUrl) {
      return
    }

    // set length
    // can't do it inside _save() callback, because there is no 'lengthISO' property inside anymore
    if (type === 'default') {
      // validation for length
      if (vod.lengthISO.getHours() === 0 && vod.lengthISO.getMinutes() === 0 && vod.lengthISO.getSeconds() === 0) {
        vm.lengthError = true
        return
      }
      vod.length = ('0' + vod.lengthISO.getHours()).slice(-2) +
        ':' + ('0' + vod.lengthISO.getMinutes()).slice(-2) +
        ':' + ('0' + vod.lengthISO.getSeconds()).slice(-2)
    }

    resetOfflineExpirationIfDisabled(vm.vod)

    vm.setDisable()

    if (type === 'default') {
      vod._save(vod => {
        if (vod.networks.length === vm.listOfNetworks.length) {
          vod.networks = []
        }
      })
        .then(vm.location(vod).reload).then(vm.afterSaveActions)
        .catch(vm.unsetDisable)
    } else {
      vm.currentVodState.tmdbId = vm.selectedVod.tmdbId
      vm.currentVodState._save(vod => {
        if (vod.networks.length === vm.listOfNetworks.length) {
          vod.networks = []
        }
      })
        .then(() => {
          if (type === 'fromTMDB') {
            vm.selectedVod = null
            vod = vm.currentVodState
            vm.currentVodState = angular.copy(vod)
          }
        })
        .then(vm.location(vod).reload).then(vm.afterSaveActions)
        .catch(vm.unsetDisable)
    }
  }

  vm.search = function (tableState = {}) {
    tableState.params = vm.searchParams
    vm.selectedVod = null
    vm.searchedByTitle = false
    if (!tableState.pagination || vm.currentTitle !== vm.searchParams.title) {
      vm.vodsFromDB = []
      tableState.pagination = {
        number: 20,
        start: 0
      }
    } else {
      if (tableState.pagination.start === 0) {
        tableState.pagination.number = 20
      }
    }

    if (vm.isLink()) {
      VOD.getVodFromTMDBByLink({
        language: vm.searchParams.language.isoCode,
        country: vm.searchParams.countryForAR.isoCode,
        url: vm.searchParams.title
      }).then(res => {
        vm.searchedByLink = true
        vm.selectedVod = res
        if (vm.isNew) {
          vm.vod.$ageRatingType = 'countryBased'
          Object.keys(vm.selectedVod).forEach(key => {
            vm.vod[key] = vm.selectedVod[key]
            if (key === 'ageRating') {
              vm.vod.$country = vm.selectedVod[key] ? vm.countries.find(c => c.isoCode === vm.selectedVod[key].country.isoCode) : {}
              vm.vod[key] = vm.selectedVod[key] ? vm.ageRatings.customAgeRatings.find(a => a.id === vm.vod.$country.id).ageRatings.find(a => a.id === vm.selectedVod[key].id) : {}
            }
          })
          vm.vod.lengthISO = vm.formatLength(vm.vod.length)
          vm.currentVodState = angular.copy(vm.vod)
          vm.activeTab = 0
          vm.selectedVod = null
        }
      })
    } else {
      VOD.loadSmartFromDB(tableState).then(res => {
        vm.currentTitle = vm.searchParams.title
        vm.vodsFromDB = res.content
        vm.isFound = !!vm.vodsFromDB.length
        vm.searchedByTitle = true
      })
    }
  }

  vm.selectVod = function (id) {
    vm.searchedByLink = false
    VOD.getVodFromTMDBById(id, {
      language: vm.searchParams.language.isoCode,
      country: vm.searchParams.countryForAR.isoCode
    }).then(res => {
      vm.searchedByLink = true
      vm.selectedVod = res
      if (vm.isNew) {
        vm.vod.$ageRatingType = 'countryBased'
        Object.keys(vm.selectedVod).forEach(key => {
          vm.vod[key] = vm.selectedVod[key]
          if (key === 'ageRating') {
            vm.vod.$country = vm.selectedVod[key] ? vm.countries.find(c => c.isoCode === vm.selectedVod[key].country.isoCode) : {}
            vm.vod[key] = vm.selectedVod[key] ? vm.ageRatings.customAgeRatings.find(a => a.id === vm.vod.$country.id).ageRatings.find(a => a.id === vm.selectedVod[key].id) : {}
          }
        })
        vm.vod.lengthISO = vm.formatLength(vm.vod.length)
        vm.currentVodState = angular.copy(vm.vod)
        vm.activeTab = 0
        vm.selectedVod = null
      }
    })
  }

  vm.disabledByTitle = function () {
    if (vm.search) {
      return !(vm.searchParams.language && vm.searchParams.countryForAR && vm.searchParams.title)
    }
    return true
  }

  /**
   * Delete VOD
   *
   * @memberof mwApp/packages.controller:AddVodCtrl
   */
  vm.delete = function () {
    if (vm.isEpisode) {
      return
    }

    vm.setDisable()
    vod._delete()
      .then(vm.location(vod).list)
      .finally(vm.unsetDisable)
  }

  vm.isLink = function () {
    return vm.searchParams.title.indexOf('https://') === 0
  }

  /**
   * Filter shows, it seems that this works faster, then filter in ui-select-choices
   *
   * @memberof mwApp/shows.controller:AddVodCtrl
   * @param  {Object} $select
   */
  vm.$timer = 0
  vm.selectSearch = ''
  vm.openCount = 0
  vm.refreshShows = function ($select = {}) {
    let search = $select.search || ''

    search = search ? search.toLowerCase() : null
    vm.openCount = $select.open ? vm.openCount + 1 : 0

    if (vm.openCount > 1) {
      vm.selectSearch = $select.search
    }

    if (vm.openCount === 1) {
      $select.search = vm.selectSearch
    }

    if ($select.open && search !== null) {
      window.clearTimeout(vm.$timer)
      vm.$timer = window.setTimeout(() => {
        Show.searchShows(search)
          .data()
          .then((data) => data.payload)
          .to(vm.shows = [])
      }, 700)
    }
  }

  /**
   * Change event for ui-select show
   *
   * @memberof mwApp/shows.controller:AddVodCtrl
   * @param  {Object} $selected
   */
  vm.selectShow = function ($selected) {
    // clear data
    vm.seasons = []
    vm.selectedSeason = null

    if ($selected) {
      const { id } = $selected
      Season.loadAll({ tvShow: { id } })
        .to(vm.seasons = [])
    }
  }

  /**
   * Upload Portrait logo
   *
   * @memberof mwApp/shows.controller:AddVodCtrl
   * @function
   */
  vm.uploadPortrait = (file) => {
    const _URL = window.URL || window.webkitURL

    const img = new Image()
    const objectUrl = _URL.createObjectURL(file)
    img.onload = function () {
      const widthPart = this.width / 2
      const heightPart = this.height / 3
      _URL.revokeObjectURL(objectUrl)

      if (file.size > 10485760) {
        alertLiteSvc.alertError('File bigger than 10 MB')
        $scope.$broadcast('dndfile.clear', true)
        return
      }
      if (widthPart / heightPart < 0.98 || widthPart / heightPart > 1.02) {
        alertLiteSvc.alertError('Vertical poster aspect ratio must be 2:3')
        $scope.$broadcast('dndfile.clear', true)
        return
      }
      return uploadLogo(file, 'vod')
        .then((url) => {
          vm.vod.imageUrl = url
        })
        .finally(() => {
          $scope.$broadcast('dndfile.clear', true)
          vm.unsetDisable()
        })
    }
    img.src = objectUrl
    vm.form.$setDirty()
  }

  /**
   * Upload Background logo
   *
   * @memberof mwApp/shows.controller:AddVodCtrl
   * @function
   */
  vm.uploadBackground = (file) => {
    const _URL = window.URL || window.webkitURL

    const img = new Image()
    const objectUrl = _URL.createObjectURL(file)
    img.onload = function () {
      const widthPart = this.width / 16
      const heightPart = this.height / 9
      _URL.revokeObjectURL(objectUrl)
      if (file.size > 10485760) {
        alertLiteSvc.alertError('File bigger than 10 MB')
        $scope.$broadcast('dndfile.clear', true)
        return
      }
      if (widthPart / heightPart < 0.98 || widthPart / heightPart > 1.02) {
        alertLiteSvc.alertError('Horizontal poster aspect ratio must be 16:9')
        $scope.$broadcast('dndfile.clear', true)
        return
      }
      return uploadLogo(file, 'background_vod')
        .then((url) => {
          vm.vod.imageBackgroundUrl = url
        }).finally(() => {
          $scope.$broadcast('dndfile.clear', true)
          vm.unsetDisable()
        })
    }
    img.src = objectUrl
    vm.form.$setDirty()
  }

  /**
   * Upload downloadable file
   *
   * @memberof mwApp/packages.controller:AddVodCtrl
   * @function
   */
  vm.uploadDownloadableFile = (file) => {
    return vod._uploadFile(vm.uploadParameters.uploadUrl, {
      value: file,
      param: vm.uploadParameters.uploadFilenameParameter
    }, file).data()
      .then((response) => {
        return vod._saveDownloadableFileLink(response)
          .then((data) => {
            vm.vod.downloadUrl = data.url
            vm.vod.downloadFilename = file.name
          }).then(() => $scope.$broadcast('dndfile.clear', true))
      }).catch((error) => {
        if (!error.statusText) {
          alertLiteSvc.alert(`External API Error. Code: ${error.status}`, 'danger')
        } else {
          alertLiteSvc.alertError(error)
        }
        $scope.$broadcast('dndfile.clear', true)
      })
  }

  /**
   * Upload encoder file
   *
   * @memberof mwApp/packages.controller:AddVodCtrl
   * @function
   */
  vm.uploadEncoderFile = (file) => {
    return vod._uploadFile(vm.encoderSourceUploadParameters.uploadUrl, {
      value: file,
      param: vm.encoderSourceUploadParameters.uploadFilenameParameter
    }, file).data()
      .then((response) => {
        return vod._saveEncoderFileLink(response)
          .then((data) => {
            vm.vod.encoderSourceDownloadUrl = data.url
            vm.vod.encoderSourceDownloadFilename = file.name
          }).then(() => $scope.$broadcast('dndfile.clear', true))
      }).catch((error) => {
        if (!error.statusText) {
          alertLiteSvc.alert(`External API Error. Code: ${error.status}`, 'danger')
        } else {
          alertLiteSvc.alertError(error)
        }
        $scope.$broadcast('dndfile.clear', true)
      })
  }

  /**
   * Find provider type by platformName from selected profiles
   * @param platformName
   * @returns {Function}
   */
  vm.findSelectedProviderType = (platformName) => {
    const selectedProfile = vm.vod?.urls[platformName]?.drmProfiles && vm.vod.urls[platformName].drmProfiles[0]
    if (!selectedProfile) {
      return null
    }

    return selectedProfile.providerType
  }

  /**
   *  Filter for drm profiles
   * @param platformName
   * @returns {Function}
   */
  $scope.filterProfiles = function (platformName) {
    return function (profile) {
      if (!vm.vod.urls[platformName] ||
        !vm.vod.urls[platformName].drmProfiles ||
        !vm.vod.urls[platformName].drmProfiles.length) {
        return true
      }

      const selectedProviderType = vm.findSelectedProviderType(platformName)
      return profile.providerType === selectedProviderType && !vm.vod.urls[platformName].drmProfiles.find((p) => p.drmType === profile.drmType)
    }
  }

  /**
   * Change Publish Now
   *
   * @memberof mwApp/vod.controller:AddVodCtrl
   */
  vm.handleChangePublish = function () {
    if (vm.vod.$scheduledPublishing) {
      vm.vod.$isSchedulerNotification = true
    }
    vm.vod.$scheduledPublishing = false
  }

  /**
   * Change Scheduled Publishing
   *
   * @memberof mwApp/vod.controller:AddVodCtrl
   */
  vm.handleChangeScheduled = function () {
    vm.vod.$isSchedulerNotification = true
    if (vm.vod.$scheduledPublishing) {
      vm.vod.enabled = false
    }
  }

  /**
   * "From" datepicker settings
   *
   * @memberof mwApp/shows.controller:AddVodCtrl
   */
  vm.dpCfg = {
    format: 'dd.MM.yyyy',
    minDate: new Date(),
    changeHandler: function (form, field = null) {
      if (field) {
        form[field].$setTouched()
      } else {
        form.dateFrom.$setTouched()
        form.dateTo.$setTouched()
      }
      const fromDate = vm.vod.$fromDate && vm.vod.$fromDate.setHours(vm.vod.$fromTime.getHours(), vm.vod.$fromTime.getMinutes())
      const toDate = vm.vod.$toDate && vm.vod.$toDate.setHours(vm.vod.$toTime.getHours(), vm.vod.$toTime.getMinutes())
      const minDateStart = fromDate > formatDateByTimezone(Date.now(), false).valueOf()
      const minDateEnd = toDate > formatDateByTimezone(Date.now(), false).valueOf()
      if (field === 'dateFrom' || !field) {
        form.dateFrom.$setValidity('minDate', minDateStart)
        form.dateFrom.$setValidity('after', true)

        if (fromDate && toDate) {
          const after = toDate > fromDate
          if (vm.vod.$toDateUnlimited) {
            form.dateFrom.$setValidity('after', true)
            form.dateTo.$setValidity('earlier', true)
          } else {
            if (form.dateTo.$error && form.dateTo.$error.earlier === true) {
              form.dateTo.$setValidity('earlier', after)
            }
            form.dateFrom.$setValidity('after', after)
          }
        }
      }
      if (field === 'dateTo' || !field) {
        form.dateTo.$setValidity('earlier', true)
        form.dateTo.$setValidity('minDate', true)
        if (!vm.vod.$toDateUnlimited) {
          form.dateTo.$setValidity('minDate', minDateEnd)
          if (fromDate && toDate) {
            const earlier = toDate > fromDate
            if (form.dateFrom.$error && form.dateFrom.$error.after === true) {
              form.dateFrom.$setValidity('after', earlier)
            }
            form.dateTo.$setValidity('earlier', earlier)
          }
        } else {
          form.dateFrom.$setValidity('after', true)
          form.dateFrom.$setValidity('earlier', true)
          form.dateTo.$setValidity('after', true)
          form.dateTo.$setValidity('earlier', true)
        }
      }
    }
  }

  /**
   * Handle open "from" datepicker
   *
   * @memberof mwApp/shows.controller:AddVodCtrl
   */
  vm.openFrom = function () {
    vm.dpCfg.fromOpened = true
  }

  /**
   * Handle open "to" datepicker
   *
   * @memberof mwApp/shows.controller:AddVodCtrl
   */
  vm.openTo = function () {
    vm.dpCfg.toOpened = true
  }

  vm.stbUrlAttention = function (url) {
    const webPlatform = vm.platformTypes.find(p => p.name === 'WEB')
    let webPlatformChecked = false
    if (webPlatform) {
      webPlatformChecked = webPlatform.checked
    }
    if (webPlatformChecked) {
      return false
    } else {
      return vm.urlAttention(url)
    }
  }

  vm.urlAttention = function (url) {
    if (url) {
      return url.slice(0, 7) === 'http://'
    } else {
      return false
    }
  }

  vm.stbTrailerUrlAttention = function (url) {
    const webPlatform = vm.platformTypes.find(p => p.name === 'WEB')
    let webTrailerChecked = false
    if (webPlatform) {
      webTrailerChecked = webPlatform.checked && webPlatform.trailerChecked
    }
    if (webTrailerChecked) {
      return false
    } else {
      return vm.trailerUrlAttention(url)
    }
  }

  vm.trailerUrlAttention = function (url) {
    if (url) {
      return url.slice(0, 7) === 'http://'
    } else {
      return false
    }
  }

  /**
   * Handle add tag to VOD-model
   *
   * @memberof mwApp/vod.controller:AddVodCtrl
   */
  vm.addTag = (item) => {
    const { LIMIT } = TAG_CUSTOM_ERROR_TYPES
    if (vm.vod.tags.find(tag => tag.name === item.name)) { // condition for unique
      alertLiteSvc.alertError('Tag should be unique within the VOD')
    } else {
      vm.vod.tags.push({ name: item.name })
    }
    if (vm.vod.tags.length > 10) {
      ~vm.tagErrors.indexOf(LIMIT) > -1 && vm.tagErrors.push(LIMIT)
    }
  }

  vm.createTag = function (select) {
    vm.addTag({ name: select.search })
    vm.currentTag = { search: '' }
    select.open = false
  }

  vm.changeTag = function (search) {
    vm.currentTag = { search }
    const { COMMA, WORD, LENGTH } = TAG_CUSTOM_ERROR_TYPES

    if (search.includes(' ')) {
      if (!vm.tagErrors.length) {
        ~vm.tagErrors.indexOf(WORD) > -1 && vm.tagErrors.push(WORD)
      }
      return
    }
    if (search.includes(',')) {
      if (!vm.tagErrors.length) {
        ~vm.tagErrors.indexOf(COMMA) > -1 && vm.tagErrors.push(COMMA)
      }
      return
    }
    if (search.length > 15) {
      if (!vm.tagErrors.length) {
        ~vm.tagErrors.indexOf(LENGTH) > -1 && vm.tagErrors.push(LENGTH)
      }
      return
    }
    vm.tagErrors = vm.tagErrors.filter(tag => ![LENGTH, COMMA, WORD].includes(tag))
  }

  vm.hasntSearchTag = function () {
    if (vm.currentTag.search.length > 0) {
      if (!vm.tags) {
        return true
      }
      return !vm.tags.find(tag => tag.name === vm.currentTag.search) && !vm.vod.tags.find(tag => tag.name === vm.currentTag.search)
    }
    return false
  }

  /**
   * Handle remove tag from VOD-model
   *
   * @memberof mwApp/vod.controller:AddVodCtrl
   */
  vm.removeTag = (tag) => {
    const { LIMIT } = TAG_CUSTOM_ERROR_TYPES
    vm.vod.tags.splice(vm.vod.tags.findIndex(t => t.name === tag.name), 1)
    if (vm.vod.tags.length <= 10) { // condition for limit
      vm.tagErrors.splice(vm.tagErrors.indexOf(LIMIT), 1)
    }
  }

  /**
   * Change drm profile callback function
   * @param {object} platformName
   * @returns {Function}
   */
  vm.changeDrmProfile = (platformName) => {
    if (platformName.drmProfiles.length) {
      platformName.kek = null
    }
  }

  /**
   * Search content params with default values
   *
   * @memberof mwApp/vod.controller:AddVodCtrl
   * @type {Object}
   */
  vm.searchTagsParams = {
    search: '',
    page: 0,
    last: false
  }

  /**
   * Filter content, it seems that this works faster, then filter in ui-select-choices
   *
   * @memberof mwApp/vod.controller:AddVodCtrl
   * @param  {Object} $select
   */
  vm.$timerTags = 0
  vm.openCountTags = 0
  vm.refreshTags = function ($select = {}) {
    let search = $select.search || ''

    vm.searchTagsParams.page = 0

    search = search ? search.toLowerCase() : ''
    vm.openCountTags = $select.open
      ? vm.openCountTags + 1
      : 0

    if ($select.open) {
      window.clearTimeout(vm.$timerTags)
      if (authSvc.hasAccess('viewChannel')) {
        vm.$timerTags = window.setTimeout(() => {
          VOD.search(
            'api/tags',
            {
              search,
              page: 0,
              count: 25
            }
          ).then((result) => {
            vm.searchTagsParams.last = result.last
            vm.tags = result.content
          })
        }, 700)
      }
    }
  }

  if (authSvc.hasAccess('viewChannel')) {
    VOD.search('api/tags',
      {
        search: '',
        page: 0,
        count: 25
      }
    ).then((result) => {
      vm.searchTagsParams.last = result.last
      vm.tags = result.content
    })
  }

  /**
   * Handler for scroll event of select list
   *
   * @param event
   */
  vm.$timerTagsScroll = 0
  vm.tagsCallbackScroll = (event) => {
    const {
      page,
      last,
      search
    } = vm.searchTagsParams
    if (!last && event.currentTarget.scrollTop >= (event.currentTarget.scrollHeight - event.currentTarget.clientHeight) * 0.6) {
      window.clearTimeout(vm.$timerTagsScroll)
      if (authSvc.hasAccess('viewChannel')) {
        vm.$timerTagsScroll = window.setTimeout(() => {
          VOD.search(
            'api/tags',
            {
              search,
              page: page + 1,
              count: 25
            }
          ).then((result) => {
            vm.searchTagsParams.last = result.last
            vm.tags = vm.tags.concat(result.content)
            vm.searchTagsParams.page = result.number
          })
        }, 700)
      }
    }
  }

  /**
   * Delete selected package
   *
   * @param network
   */
  vm.deleteNetwork = function (network) {
    vm.deselectNetwork(network, vm.form)
    if (vm.vod.networks.length) {
      vm.vod.contentSets = vm.vod.contentSets.filter((cs) => cs.networkId !== network.id)
    } else {
      vm.networkSelected = null
    }
    vm.networks = [{ id: 0, name: 'All Organizations' }].concat(vm.networks.filter(n => n.id !== 0).sort((a, b) => {
      return (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)
    }))
    vm.networks = vm.networks.filter(n => n.id !== -1)
  }

  vm.selectOrganization = function () {
    if (vm.networkSelected.id === 0) {
      vm.networks = [{ id: -1, name: 'Deselect all Organization' }]
      vm.vod.networks = angular.copy(vm.listOfNetworks)
    } else if (vm.networkSelected.id === -1) {
      vm.vod.networks = []
      vm.networks = [{ id: 0, name: 'All Organizations' }].concat(vm.listOfNetworks)
      vm.networkSelected = null
    } else {
      vm.selectNetwork(vm.networkSelected)
      if (vm.vod.networks.length === 1) {
        vm.vod.contentSets = vm.vod.contentSets.filter((cs) => cs.networkId === vm.networkSelected.id)
      }
      if (vm.networks.length === 1) {
        vm.networks = [{ id: -1, name: 'Deselect all Organization' }]
      }
    }
  }

  vm.showAllNetworks = false
  vm.showButton = function () {
    const container = document.getElementById('networks-container')
    return container.scrollHeight > 210
  }

  vm.toggleShowAllNetworks = function () {
    vm.showAllNetworks = !vm.showAllNetworks
  }

  vm.hasFlag = function (flag) {
    return authSvc.hasEnabledFlag(flag)
  }

  $scope.$watch('vm.vod.lengthISO', (newValue, oldValue) => {
    vm.lengthError = oldValue !== newValue && vm.vod.lengthISO.getHours() === 0 && vm.vod.lengthISO.getMinutes() === 0 && vm.vod.lengthISO.getSeconds() === 0
  })

  $scope.$on('$viewContentLoaded', function () {
    vm.location.setGoBackLink('vods')
  })

  vm.ursulaEnabled = authSvc.hasEnabledFlag('FEATURE_URL_INTELLIGENCE_ENABLED')

  $timeout(vm.unsetDisable)
}
